module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0101.jpg?v=511f323a";